<div class="notification-action file-compression-start">
  <div class="event-item">
    <span class="notification-activity date">{{notification.created | date:'dd MMM yyyy'}}</span>
    <div class="header-notification">
      <h3><span>Preparing files</span></h3>
    </div>
    <p>Your file will download shortly, we are compressing the files.</p>
  </div>
</div>